/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * Extracts the tab number from a Certona container ID
 * @param containerId - Container ID in format "tab1_rr", "tab2_rr", etc.
 * @returns The tab number (1, 2, 3, 4) or null if not found
 */
export function extractTabNumber(containerId?: string): number | null {
  if (!containerId) {
    return null;
  }
  const match = containerId.match(/tab(\d+)_rr/i);
  return match ? parseInt(match[1], 10) : null;
}
